module.exports = __webpack_public_path__ + "media/incorrect.017047cd.mp3";